var render = function render(){var _vm=this,_c=_vm._self._c;return _c('password',{attrs:{"default-class":"form-control password-meter","name":_vm.id,"placeholder":_vm.placeholder,"id":_vm.id,"toggle":true,"secure-length":_vm.minimalCharCount},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})
}
var staticRenderFns = []

export { render, staticRenderFns }